import CategoriesOption from 'owa-categories-option/lib/CategoriesOption';
import { loadFavorites, loadOutlookFavorites } from 'owa-favorites';
import { isControlFeatureEnabled } from 'owa-controls-feature-flags';
import { loadMailFolders } from 'owa-mail-folder-store';
var categoriesSubCategory = {
    key: 'categories',
    titleStringKey: 'optionSubcategory_category',
    options: [CategoriesOption],
    onSelected: function () {
        loadMailFolders();
        if (isControlFeatureEnabled('tri-favorites-roaming')) {
            // Load roaming favorites from the Outlook Favorites.
            loadOutlookFavorites();
        }
        else {
            // Load beta favorites from FavoritesNodes
            loadFavorites();
        }
        return Promise.resolve(true);
    },
};
export default categoriesSubCategory;
//# sourceMappingURL=categoriesSubCategory.js.map